import { formatVnd } from '../core/envelope.js';

/** Exit codes so scripts and CI can branch on the failure mode. */
export const EXIT = {
  OK: 0,
  ERROR: 1,
  USAGE: 2,
  AUTH: 3,
  CONNECTION: 4,
} as const;

function colorsEnabled(): boolean {
  if (process.env.NO_COLOR !== undefined && process.env.NO_COLOR !== '') {
    return false;
  }
  if (process.env.FORCE_COLOR !== undefined && process.env.FORCE_COLOR !== '') {
    return true;
  }
  return process.stdout.isTTY === true;
}

const ESC = '\u001b';

function wrap(open: string, close: string) {
  return (text: string): string =>
    colorsEnabled() ? `${ESC}[${open}m${text}${ESC}[${close}m` : text;
}

export const style = {
  bold: wrap('1', '22'),
  dim: wrap('2', '22'),
  red: wrap('31', '39'),
  green: wrap('32', '39'),
  yellow: wrap('33', '39'),
  blue: wrap('34', '39'),
  cyan: wrap('36', '39'),
};

export const symbols = {
  ok: () => style.green('✓'),
  fail: () => style.red('✗'),
  warn: () => style.yellow('!'),
};

export function out(message = ''): void {
  process.stdout.write(`${message}\n`);
}

export function err(message = ''): void {
  process.stderr.write(`${message}\n`);
}

/** Two-column key/value block with aligned values. */
export function fields(rows: [string, string][], indent = '  '): string {
  const width = rows.reduce((max, [key]) => Math.max(max, key.length), 0);
  return rows
    .map(([key, value]) => `${indent}${style.dim(key.padEnd(width))}  ${value}`)
    .join('\n');
}

export function money(amount: string | number): string {
  return formatVnd(amount);
}

export function relativeTime(iso: string | null | undefined): string {
  if (iso === null || iso === undefined) return style.dim('never');
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return iso;

  const seconds = Math.round((Date.now() - then) / 1000);
  const abs = Math.abs(seconds);
  const suffix = seconds >= 0 ? 'ago' : 'from now';

  if (abs < 60) return `${String(abs)}s ${suffix}`;
  if (abs < 3600) return `${String(Math.round(abs / 60))}m ${suffix}`;
  if (abs < 86_400) return `${String(Math.round(abs / 3600))}h ${suffix}`;
  return `${String(Math.round(abs / 86_400))}d ${suffix}`;
}
